import { useGlobalStore } from "@/store/GlobalStore";
import { Zone } from "project-config/constants";

export function ChildBalance({
  rmbBalance,
  usdBalance,
}: {
  rmbBalance: number;
  usdBalance: number;
}) {
  const { userInfo } = useGlobalStore();
  return (
    <span>
      {userInfo?.zone === Zone.Domestic ? `￥${rmbBalance}` : `$${usdBalance}`}
    </span>
  );
}
